import { useEffect, useRef } from "react"
import { useIsOnItemPage } from "@/components/items/utils"

/**
 * A hook that preserves the value of any object when navigating to an item page.
 *
 * This is useful for preserving filters on the collection page.
 */
export function usePreserveValuePriorToItemPage<T>(value: T): T {
  const isOnItemPage = useIsOnItemPage()
  const savedValueRef = useRef<T>(value)

  // Only update the saved value when we're not on an item page
  useEffect(() => {
    if (!isOnItemPage) {
      savedValueRef.current = value
    }
  }, [isOnItemPage, value])

  // If on an item page, return the saved value, otherwise return the current value
  return isOnItemPage ? savedValueRef.current : value
}
